import { Component, ViewChild, Input, Pipe, PipeTransform, NgZone, Output, EventEmitter, trigger, state, style, transition, animate } from '@angular/core';
import { Nav, ModalController, Platform } from 'ionic-angular';

import { MenuEntry } from './menu-entry';
import { OnInit } from '@angular/core/src/metadata/lifecycle_hooks';

@Component({
  selector: 'lm-main-menu',
  templateUrl: 'main-menu.component.html',
  animations: [
    trigger('selectionState', [
      state('inactive', style({
        transform: 'scale(1)'
      })),
      state('active',   style({
        transform: 'scale(1.1)'
      })),
      transition('inactive => active', animate('100ms ease-in')),
      transition('active => inactive', animate('100ms ease-out'))
    ])
  ]
})
export class MainMenuComponent {
  @ViewChild(Nav) public set nav(nav: Nav) {
    this._nav = nav;
    if (this.menues !== undefined && this.menues.length > 0) {
      this.selectedIndex = 0;

      this.nav.setRoot(this.menues[0].component, this.menues[0].userdata);
    }
  }

  public get nav(): Nav {
    return this._nav;
  }

  @Input() public versionText: string;

  @Input() public set menues(menues: MenuEntry[]) {
    this._menues = menues;

    this.selectedIndex = 0;
  }

  public get menues(): MenuEntry[] {
    return this._menues;
  }

  @Output() public logout = new EventEmitter<void>();

  private _menues: MenuEntry[];
  private _nav: Nav;
  private selectedIndex = 0;
  private breakWidth = 800;
  private isWideScreen = true;
  private menuAlwaysVisible = true;

  constructor(private modalController: ModalController, private ngZone: NgZone, private platform: Platform) {
    this.isWideScreen = window.innerWidth >= this.breakWidth;

    this.menuAlwaysVisible = !platform.is('mobile') || platform.is('tablet');
    // this.menuAlwaysVisible = this.isWideScreen;
    window.onresize = (e) => {
      ngZone.run(() => {
        this.isWideScreen = window.innerWidth >= this.breakWidth;
        // this.menuAlwaysVisible = this.isWideScreen;
      });
    };
  }

  public openPage(entry: MenuEntry, idx: number) {
    // Reset the content nav to have just this page
    // we wouldn't want the back button to show in this scenario

    this.selectedIndex = idx;
    this.nav.setRoot(entry.component, entry.userdata);
  }

  public didTapLogoutButton() {
    this.logout.emit();
    console.log('user tapped logged out');
  }
}



// WEBPACK FOOTER //
// ./src/app/features/shared/components/main-menu/main-menu.component.ts